import { useEffect, useRef, MutableRefObject, ForwardedRef } from 'react'
import { isCallable } from '@afterpay/utils'

type Refs = ForwardedRef<any> | MutableRefObject<any>

export const useCombinedRef = (...refs: Refs[]): MutableRefObject<any> => {
  const targetRef = useRef()

  useEffect(() => {
    refs.forEach((ref) => {
      if (ref === null) {
        return
      }
      if (isCallable(ref)) {
        ref(targetRef.current)
      } else {
        ref.current = targetRef.current
      }
    })
  }, [refs])

  return targetRef
}
